import { BehaviorSelectionOptionsType } from './types';

export const BEHAVIOR_SELECTION_OPTIONS: BehaviorSelectionOptionsType = [
  { id: 'playful', title: '😉 Playful' },
  { id: 'dominant', title: '😈 Dominant' },
  { id: 'shy', title: '🤭 Shy' },
  { id: 'wild', title: '🔥 Wild' },
];
